import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

interface SelectedEntityProps {
    value: string;
    onChange: (event: SelectChangeEvent<string>) => void;
    options: { value: string; label: string }[];
}

const SelectedEntity: React.FC<SelectedEntityProps> = ({ value, onChange, options }) => {
    return (
        <FormControl sx={{ height: '3.5rem' }}>
            <InputLabel sx={{ color: 'black' }}>Entité</InputLabel>
            <Select value={value} onChange={onChange} style={{ width: '100%' }} label="Entité">
                {options.map((option, index) => (
                    <MenuItem key={index} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default SelectedEntity;
